export default __webpack_public_path__ + "static/media/education.1745ab76.jpg";